module.exports = __webpack_public_path__ + "static/media/buckaroo1.c7f62fed.jpg";